import script from "./VensoInvoiceRequest.vue?vue&type=script&setup=true&lang=ts"
export * from "./VensoInvoiceRequest.vue?vue&type=script&setup=true&lang=ts"

import "./VensoInvoiceRequest.vue?vue&type=style&index=0&id=3bdb3e36&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bdb3e36"]])

export default __exports__